import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, VStack, Heading, Box, Spinner, Alert, AlertIcon, Button, Badge, HStack } from '@chakra-ui/react';
import DOMPurify from 'dompurify';
import { api } from '../lib/api';

export default function FlashcardView() {
  const { id } = useParams<{ id: string }>();
  const [card, setCard] = useState<any>(null);
  const [flipped, setFlipped] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    api.getFlashcard(Number(id))
      .then(setCard)
      .catch(() => setError('Flashcard yüklenemedi.'));
  }, [id]);

  if (error) return <Container maxW="md" py={6}><Alert status="warning"><AlertIcon />{error}</Alert></Container>;
  if (!card) return <VStack p={12}><Spinner /></VStack>;

  return (
    <Container maxW="md" py={6}>
      <VStack spacing={4} align="stretch">
        {card.topic && <HStack><Badge colorScheme="purple">{card.topic.name}</Badge></HStack>}
        <Box
          minH="240px" p={6} borderRadius="lg"
          bg={flipped ? 'flashcardBackGradient' : 'flashcardFrontGradient'}
          color="white"
          display="flex" alignItems="center" justifyContent="center"
          cursor="pointer"
          onClick={() => setFlipped((v) => !v)}
        >
          <Box dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(flipped ? card.backText : card.frontText) }} />
        </Box>
        <Button onClick={() => setFlipped((v) => !v)}>{flipped ? 'Ön yüze dön' : 'Cevabı göster'}</Button>
      </VStack>
    </Container>
  );
}
